<h1 class="pb-5">{{ 'PRODUCTS.title' | translate: { count: 0 } }}</h1>
<app-cards-basic title="{{ 'PRODUCTS.list' | translate }}" [loading]="isLoading">
  @defer {
    <mat-nav-list>
      @for (product of productList; track product) {
        <a mat-list-item routerLink="{{product.id}}" class="list-border-bottom">
          <span matListItemTitle>{{ product.translations.en.title }}</span>
          <button mat-icon-button (click)="confirmDelete(product.id, $event)" aria-label="Delete" class="trailing-end-button">
            <mat-icon>
              <span class="material-symbols-outlined">delete</span>
            </mat-icon>
          </button>
        </a>
      }
    </mat-nav-list>

    <button mat-flat-button
            color="primary"
            type="button"
            [routerLink]="['new-product' | localize]"
            class="bp-button">
      {{ 'PRODUCTS.create' | translate }}
    </button>



  } @loading (minimum 0ms) {
    <mat-spinner diameter="30" strokeWidth="1" style="margin:0 auto;"></mat-spinner>
  }
</app-cards-basic>

